exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.deficient[data-v-34637a34] {\n  color: #ff5f58;\n}\ntr.disabled[data-v-34637a34] {\n  opacity: 0.4;\n}\ntr.disabled .deficient[data-v-34637a34] {\n  color: inherit;\n}\n", ""]);

// exports
